import { DomainSerializer } from '../../../common/domain.serializer';
import { ConfiguracaoLogin } from './configuracao-login';

export class ConfiguracaoLoginSerializer extends DomainSerializer<ConfiguracaoLogin> {
}
